import React, { useEffect } from 'react';
import { CardComponent } from '../CardComponent';
import { selectClient } from '../clients/clientsSlice';
import { useAppDispatch } from '../hooks';
import { Modal, ModalContent } from "../../../components/ui/Modal";
import {
  Alert,
  Col,
  Form,
  FormGroup,
  Input,
  Row,
} from "reactstrap";
import { Button } from "../../../components/ui/Button";
import { DataGrid } from "../../../components/ui/DataGrid";
import { HttpRequest } from "../../../util/http";
import { FontAwesomeIcon } from "../../../components/ui/FontAwesomeIcon";
import Card from 'reactstrap/lib/Card';

interface IReportUsersEndpointResponse {
  data: {
    availableUsers: IUser[];
    licenseTypes: ILicenseType[];
    registeredUsers: IReportUser[];
  }
}

interface IUser {
  id: number;
  username: string;
}

interface ILicenseType {
  id: number;
  report_user_type: string;
  default_list_price: number;
}

interface IReportUser {
  userId: number;
  tableauUserName: string;
  reportUserType: string | number;
  listPrice: number;
  tableauClientSecret?: string;
  tableauClientId: string;
  tableauClientSecretId: string;
}

export function ClientTable(props) {
  const dispatch = useAppDispatch();
  const { isLoading, customerTypes, setNewClientModal, search, setSearch,
    allClientsStatusHandleChange, allClientStatus, message, setMessage,
    filteredClients, modifyCustomerType, modifyDynamicAge, redirectToQuestionnaires,
    loadIpRestrictions, getCategories, openEditPermissions, openDashboardModal, addToETL,
    syncSuperUsers,
  } = props;

  const [openHasLeadershipInsightsUsersModal, setOpenHasLeadershipInsightsUsersModal] = React.useState(false);
  const [clickedClient, setClickedClient] = React.useState('');
  const [reportUsers, setReportUsers] = React.useState<IReportUser[]>([]);
  const [licenseTypes, setLicenseTypes] = React.useState<ILicenseType[]>([]);
  const [availableUsers, setAvailableUsers] = React.useState<IUser[]>([]);
  const [formUser, setFormUser] = React.useState<IReportUser>({
    userId: 0,
    tableauUserName: '',
    reportUserType: '',
    listPrice: 0,
    tableauClientId: '',
    tableauClientSecret: '',
    tableauClientSecretId: '',
  });
  const [loadingReportUsersData, setLoadingReportUsersData] = React.useState(false);
  const [reportUserError, setReportUserError] = React.useState('');
  const [currencyValue, setCurrencyValue] = React.useState('');
  const [crudLoading, setCrudLoading] = React.useState(false);

  const formatCurrency = (num) => {
    // if (isNaN(num) || num === null || num === '') { return ''; }
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(num);
  };

  const handleFocus = (e) => {
    const numeric = formUser.listPrice ? formUser.listPrice : '';
    setCurrencyValue(numeric.toString());
  };

  useEffect(() => {
    setCurrencyValue(formatCurrency(formUser.listPrice));
  }, [formUser.listPrice]);

  useEffect(() => {
    if (openHasLeadershipInsightsUsersModal) {
      $('#report-username-select').material_select('destroy');
      $('#report-user-type-select').material_select('destroy');
    }
  }, [openHasLeadershipInsightsUsersModal]);

  useEffect(() => {
    if (clickedClient.length > 0) {
      setLoadingReportUsersData(true);
      const method = 'POST';
      const data = {
        requestedClient: clickedClient,
      };
      HttpRequest.fetch<IReportUsersEndpointResponse>('/web/v1/admin/clients/report-users', {
        data,
        method
      }).then((response) => {
        setReportUsers(response.data.registeredUsers);
        setLicenseTypes(response.data.licenseTypes);
        setAvailableUsers(response.data.availableUsers.filter((user) => {
          return !response.data.registeredUsers.some((registeredUser) => registeredUser.tableauUserName === user.username);
        }));
        setLoadingReportUsersData(false);
        $('#report-username-select').material_select('destroy');
        $('#report-user-type-select').material_select('destroy');
      });
    }
  }, [clickedClient]);

  useEffect(() => {
    if (availableUsers.length > 0 && licenseTypes.length > 0) {
      setFormUser({
        ...formUser,
        userId: availableUsers[0].id,
        tableauUserName: availableUsers[0].username,
        reportUserType: licenseTypes[0].id,
        listPrice: licenseTypes[0].default_list_price,
      });
    }
  }, [availableUsers, licenseTypes]);

  const addInsightsUser = (e) => {
    e.preventDefault();
    setCrudLoading(true);
    const method = 'POST';
    const data = {
      requestedClient: clickedClient,
      user_id: formUser.userId,
      tableau_username: formUser.tableauUserName,
      report_user_type_id: formUser.reportUserType,
      list_price: formUser.listPrice === 0 ? '0.00' : formUser.listPrice,
      tableau_clientid: formUser.tableauClientId,
      tableau_client_secret: formUser.tableauClientSecret,
      tableau_client_secret_id: formUser.tableauClientSecretId,
    }
    HttpRequest.fetch('/web/v1/admin/clients/report-users/create', { data, method }).then((res: any) => {
      setCrudLoading(false);
      if (res.data.error === undefined) {
        formUser.reportUserType = licenseTypes.find((licenseType) => licenseType.id === formUser.reportUserType).report_user_type;
        setReportUsers([...reportUsers, formUser]);
        setAvailableUsers(availableUsers.filter((user) => user.id !== formUser.userId));
        setFormUser({
          userId: 0,
          tableauUserName: '',
          reportUserType: '',
          listPrice: 0,
          tableauClientSecret: '',
          tableauClientId: '',
          tableauClientSecretId: '',
        });
        if (reportUserError.length > 0) {
          setReportUserError('');
        }
      } else {
        setReportUserError(res.data.error);
      }
    });
  };

  const removeInsightsUser = (userId: number) => {
    setCrudLoading(true);
    const selectedUser = reportUsers.find((user) => user.userId === userId);

    const method = 'POST';
    const data = {
      requestedClient: clickedClient,
      user_id: selectedUser.userId,
      tableau_username: selectedUser.tableauUserName,
      report_user_type_id: selectedUser.reportUserType,
      list_price: selectedUser.listPrice === 0 ? '0.00' : selectedUser.listPrice,
      tableau_clientid: selectedUser.tableauClientId,
      tableau_client_secret: selectedUser.tableauClientSecret,
      tableau_client_secret_id: selectedUser.tableauClientSecretId,
    }
    HttpRequest.fetch('/web/v1/admin/clients/report-users/delete', { data, method }).then((res: any) => {
      setCrudLoading(false);
      if (res.data.error === undefined) {
        setReportUsers(reportUsers.filter((user) => user.userId !== userId));
        setAvailableUsers([...availableUsers, {
          id: userId,
          username: selectedUser.tableauUserName,
        }]);
        if (reportUserError.length > 0) {
          setReportUserError('');
        }
      } else {
        setReportUserError(res.data.error);
      }
    });
  };

  const handleListPriceChange = () => {
    return (e) => {
      setCurrencyValue(e.target.value);
    };
  }

  const handleInputChange = (e) => {
    // Check if the input name is 'tableauUserName' or 'reportUserType'
    // and update the formUser state accordingly
    if (e.target.name === 'tableauUserName') {
      const selectedUser = availableUsers.find((user) => user.id === parseInt(e.target.value, 10));
      setFormUser({
        ...formUser,
        userId: selectedUser.id,
        tableauUserName: selectedUser.username,
      });
    } else if (e.target.name === 'reportUserType') {
      const selectedLicenseType = licenseTypes.find((licenseType) => licenseType.id === parseInt(e.target.value, 10));
      setFormUser({
        ...formUser,
        reportUserType: selectedLicenseType.id,
        listPrice: selectedLicenseType.default_list_price,
      });
    }
  };

  const handleBlur = (e) => {
    // Remove any non-numeric characters (except for . and -)
    const numericValue = parseFloat(e.target.value.replace(/[^0-9.-]+/g, ''));
    if (!isNaN(numericValue)) {
      setCurrencyValue(formatCurrency(numericValue));
      setFormUser({
        ...formUser,
        listPrice: numericValue,
      });
    } else {
      setCurrencyValue('');
    }
  };

  return (
    <div>
      <CardComponent
        title={'Clients'}
        titleStyles={{ display: 'inline-block', fontSize: '2.92rem', fontWeight: 400, marginLeft: '30px', marginTop: '20px' }}
        styles={{ background: 'white' }}
        isLoading={isLoading}
      >
        <div>
          <div style={{ marginTop: '12px' }}>
            <a className="waves-effect waves-light btn"
              style={{ marginLeft: '12px' }}
              onClick={() => { setNewClientModal(true) }}
            >
              Add Client
            </a>
            <a className="waves-effect waves-light btn"
              style={{ marginLeft: '5px' }}
              href="customer_types?back=clients"
            >
              Edit Customer Types
            </a>
            <a className="waves-effect waves-light btn"
              style={{ marginLeft: '5px' }}
              onClick={() => {
                if (confirm('This process will sync all super users with all clients. It may take 1-2 minutes to complete. Continue?')) {
                  syncSuperUsers();
                }
              }}
            >
              Sync Super Users
            </a>
            <div className='blacklight' style={{ marginTop: '15px', width: '425px', float: 'right', color: 'grey' }}>
              <div className='blacklight' style={{ display: 'inline-block', marginTop: '15px', width: '250px', color: 'black !important' }}>
                <label style={{ fontSize: '15px', color: 'grey' }}>Search
                  <input
                    style={{ width: '125px', height: "26px", marginLeft: "8px", fontSize: "14px", paddingLeft: "5px", color: 'black' }}
                    // defaultValue={search}
                    value={search}
                    onChange={(e) => {
                      setSearch(e.target.value)
                    }}
                  />
                </label>
                <button
                  onClick={() => { setSearch("") }}
                  style={{ backgroundColor: "white", border: "none", marginLeft: "5px" }}
                >
                  X
                </button>
              </div>
              <div className='blacklight' style={{ display: 'inline-block', width: '120px', marginRight: '25px' }}>
                <label
                  style={{ color: 'grey', fontSize: '12px' }}
                >
                  Status
                </label>
                <div className='blacklight'>
                  <select
                    className="browser-default"
                    onChange={allClientsStatusHandleChange}
                    value={allClientStatus}
                  // defaultValue={allClientStatus}
                  >
                    <option value="0">Active</option>
                    <option value="1">In-Active</option>
                    <option value="2">Testing</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div style={{ marginTop: '10px', width: '325px' }}>
            <label style={{ fontSize: '22px', marginLeft: '25px', color: 'grey' }}>
              {message}
            </label>
            {message.length > 1 ?
              <button
                className='blacklight'
                onClick={() => { setMessage("") }}
                style={{ backgroundColor: "white", border: "none", marginLeft: "2px", color: 'grey' }}
              >
                <i className=" blacklight material-icons">cancel</i>
              </button>
              : ''}
          </div>
          {/* Clients Table */}
          <div style={{ margin: '5px' }}>
            <table className="bordered responsive-table centered">
              <thead>
                <tr>
                  <th>Client Name</th>
                  <th>Abbreviation</th>
                  <th>Customer Type</th>
                  <th>Dynamic Age - Days</th>
                  <th>Dashboards (Current Default)</th>
                  <th>Questionnaires</th>
                  <th>Restrict Access by IP</th>
                  <th>Leadership Insights Users</th>
                  <th>Latest Survey Date</th>
                  <th>Edit Client</th>
                </tr>
              </thead>
              <tbody>
                {filteredClients.map((client) => {
                  const {
                    id, name, abbr, customer_type, customer_type_id, dynamic_age, default_dashboard,
                    restricted, latestLoad, default_page_id, all_surveys_default_question_qid,
                    all_surveys_default_question_val, default_questions, classic_customer, allowBaseQuestion,
                    default_url, domain, editcommentcodes, editdetails, enableActionAlertUpdates, enableActionAlerts,
                    enableRankingReports, respondentEmail, respondentName, respondentPhone, status,
                    enableIndividualSurveysDelete, usesSampleApp, hasLeadershipInsightsUsers, jhInstRouteId, jhInstEnv,
                  } = client;
                  return (
                    <tr key={id}>
                      <td>
                        {name}
                      </td>
                      <td>
                        {abbr}
                      </td>
                      <td>
                        <a className="link"
                          onClick={() => { modifyCustomerType(name, abbr, customerTypes) }}
                        >
                          {customer_type}
                        </a>
                      </td>
                      <td>
                        <a className="link"
                          onClick={() => { modifyDynamicAge(name, abbr, dynamic_age) }}
                        >
                          {dynamic_age}
                        </a>
                      </td>
                      <td>
                        <span
                          className="link"
                          onClick={() => {
                            openDashboardModal()
                            dispatch(selectClient(client));
                          }}
                        >
                          {default_dashboard}
                        </span>
                      </td>
                      <td>
                        <a className="link"
                          onClick={() => { redirectToQuestionnaires(abbr) }}
                        >
                          <i className="material-icons link">assessment</i>
                        </a>
                      </td>
                      <td>
                        <a className="link"
                          onClick={() => { loadIpRestrictions(abbr, name) }}
                        >
                          {restricted}
                        </a>
                      </td>
                      <td>
                        <a className="link"
                          onClick={() => {
                            setOpenHasLeadershipInsightsUsersModal(!openHasLeadershipInsightsUsersModal)
                            if (clickedClient !== abbr) {
                              setClickedClient(abbr)
                              setAvailableUsers([])
                              setReportUsers([])
                            }
                          }}
                        >
                          {hasLeadershipInsightsUsers ? 'Yes' : 'No'}
                        </a>
                      </td>
                      {latestLoad === null ?
                        <td>
                          <a className="link"
                            onClick={() => { addToETL(abbr) }}
                          >
                            Add to new etl
                          </a>
                        </td>
                        :
                        <td>
                          {latestLoad}
                        </td>
                      }
                      <td>
                        <a className="link"
                          onClick={() => { getCategories(id, name, abbr, customer_type, customer_type_id, dynamic_age, default_dashboard, restricted, latestLoad, default_page_id, all_surveys_default_question_qid, all_surveys_default_question_val, default_questions, classic_customer, allowBaseQuestion, default_url, domain, editcommentcodes, editdetails, enableActionAlertUpdates, enableActionAlerts, enableRankingReports, respondentEmail, respondentName, respondentPhone, status, enableIndividualSurveysDelete, usesSampleApp, jhInstRouteId, jhInstEnv) }}
                        >
                          <i className="material-icons link">mode_edit</i>
                        </a>
                        <a className="link"
                          onClick={() => { openEditPermissions(name, abbr) }}
                        >
                          <i className="material-icons link">lock</i>
                        </a>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </CardComponent>
      <Modal open={openHasLeadershipInsightsUsersModal}>
        <ModalContent>
          <h3>{clickedClient.toUpperCase()}&nbsp;{loadingReportUsersData && <i className="fa fa-cog fa-spin" />}</h3>
          {!loadingReportUsersData &&
            <div className="mt-3">
              <Button style={{ float: 'right' }} onClick={() => { setOpenHasLeadershipInsightsUsersModal(false) }}>CLOSE</Button>
              {crudLoading &&
                <div className="mt-1">
                  <div className="progress">
                    <div className="indeterminate"></div>
                  </div>
                </div>
              }
            </div>
          }
          <div className="clearfix" />
          <div className="blacklight mt-3">
            <Alert className="fadeIn" color="danger" isOpen={reportUserError.length > 0} toggle={() => { setReportUserError('') }}>
              {reportUserError}
            </Alert>
          </div>
          {!loadingReportUsersData &&
            <div className="blacklight">
              <div className="mt-3">
                <Card style={{ padding: '10px' }}>
                  <Form onSubmit={(e) => addInsightsUser(e)}>
                    <Row>
                      <Col md={3}>
                        <FormGroup>
                          <Input onChange={(e) => handleInputChange(e)} type="select" name="tableauUserName" id="report-username-select" disabled={availableUsers.length === 0}>
                            {availableUsers.map((user) => {
                              return (
                                <option key={user.id} value={user.id}>{user.username}</option>
                              );
                            })}
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col md={3}>
                        <FormGroup>
                          <Input onChange={(e) => handleInputChange(e)} type="select" name="reportUserType" id="report-user-type-select" disabled={availableUsers.length === 0}>
                            {licenseTypes.map((licenseType) => {
                              return (
                                <option key={licenseType.id} value={licenseType.id}>{licenseType.report_user_type}</option>
                              );
                            })}
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col md={2}>
                        <FormGroup>
                          <Input type="text" id="report-license-price-input" value={currencyValue}
                            onChange={handleListPriceChange()} onFocus={handleFocus} onBlur={handleBlur} disabled={availableUsers.length === 0} />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={4}>
                        <Input type="text" id="report-tableau-client-id-input" placeholder='Tableau Client ID' value={formUser.tableauClientId}
                          onChange={(e) => {
                            setFormUser({
                              ...formUser,
                              tableauClientId: e.target.value,
                            });
                          }} disabled={availableUsers.length === 0} />
                      </Col>
                      <Col md={3}>
                        <Input type="text" id="report-tableau-client-secret-id-input" placeholder='Tableau Client Secret ID' value={formUser.tableauClientSecretId}
                          onChange={(e) => {
                            setFormUser({
                              ...formUser,
                              tableauClientSecretId: e.target.value,
                            });
                          }} disabled={availableUsers.length === 0} />
                      </Col>
                      <Col md={3}>
                        <Input type="password" id="report-tableau-client-secret-input" placeholder='Tableau Client Secret' value={formUser.tableauClientSecret}
                          onChange={(e) => {
                            setFormUser({
                              ...formUser,
                              tableauClientSecret: e.target.value,
                            });
                          }} disabled={availableUsers.length === 0} />
                      </Col>
                      <Col md={2}>
                        <Button type='submit' style={{ width: '100%' }} className={!(formUser.userId > 0) ? 'btn-grey' : 'btn-primary'} color="primary" disabled={!(formUser.userId > 0)}>ADD</Button>
                      </Col>
                    </Row>
                  </Form>
                </Card>
              </div>
            </div>
          }
          {(!loadingReportUsersData && reportUsers.length > 0) &&
            <div className="blacklight">
              <div className="mt-3">
                <DataGrid<IReportUser>
                  hideInputs={reportUsers.length < 11}
                  records={reportUsers}
                  columns={[
                    { property: 'tableauUserName', header: 'User Name' },
                    { property: 'reportUserType', header: 'Report User Type' },
                    {
                      property: 'listPrice', header: 'List Price', render: (record) => {
                        return (
                          <span style={{ display: 'block', textAlign: 'right' }}>{formatCurrency(record.listPrice)}</span>
                        );
                      }
                    },
                    { property: 'tableauClientId', header: 'Tableau Client ID' },
                    { property: 'tableauClientSecretId', header: 'Tableau Client Secret ID' },
                    {
                      property: 'userId', header: 'Actions', render: (record) => {
                        return (
                          <FontAwesomeIcon icon={'trash'} size={'sm'} onClick={() => {
                            removeInsightsUser(record.userId);
                          }} />
                        );
                      }
                    },
                  ]}
                />
              </div>
            </div>
          }
          {(!loadingReportUsersData && reportUsers.length === 0 && availableUsers.length > 0) &&
            <div className="blacklight">
              <div className="mt-3">
                <Alert color="info">
                  No Insights Users have been added to this client.
                </Alert>
              </div>
            </div>
          }
          {(!loadingReportUsersData && availableUsers.length === 0 && reportUsers.length === 0) &&
            <div className="blacklight">
              <div className="mt-3">
                <Alert color="warning">
                  No available users to add.
                </Alert>
              </div>
            </div>
          }
        </ModalContent>
      </Modal>
    </div>

  )
}
